import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _CUSTOMER_TYPE_DISPLA, _CUSTOMER_ADDRESS_TYP, _CUSTOMER_ADDRESS_TYP2, _DMS_VS_DSE_COMMUNICA, _COMMUNICATION_TYPE_D, _PHONE_TYPE_VS_LABELS, _PREFERRED_COMMUNICAT, _CUSTOMER_ACCOUNTING_, _CUSTOMER_ACCOUNTING_2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _reduce from 'lodash/reduce';
import { STATUS } from './statuses';
import OPERATORS from './filterOperators';
var SHIPPING_ADDRESS = 'SHIPPING_ADDRESS';
var BILLING_ADDRESS = 'BILLING_ADDRESS';
var SITE_ADDRESS = 'SITE_ADDRESS';
export var CUSTOMER_TYPE = {
  INDIVIDUAL: 0,
  BUSINESS: 1
};
export var CUSTOMER_TYPE_DISPLAY = (_CUSTOMER_TYPE_DISPLA = {}, _defineProperty(_CUSTOMER_TYPE_DISPLA, CUSTOMER_TYPE.BUSINESS, 'Business'), _defineProperty(_CUSTOMER_TYPE_DISPLA, CUSTOMER_TYPE.INDIVIDUAL, 'Individual'), _CUSTOMER_TYPE_DISPLA);
export var CUSTOMER_ADDRESS_TYPE = (_CUSTOMER_ADDRESS_TYP = {}, _defineProperty(_CUSTOMER_ADDRESS_TYP, SHIPPING_ADDRESS, SHIPPING_ADDRESS), _defineProperty(_CUSTOMER_ADDRESS_TYP, BILLING_ADDRESS, BILLING_ADDRESS), _defineProperty(_CUSTOMER_ADDRESS_TYP, SITE_ADDRESS, SITE_ADDRESS), _CUSTOMER_ADDRESS_TYP);
export var CUSTOMER_ADDRESS_TYPE_VS_ENUM = (_CUSTOMER_ADDRESS_TYP2 = {}, _defineProperty(_CUSTOMER_ADDRESS_TYP2, SITE_ADDRESS, 0), _defineProperty(_CUSTOMER_ADDRESS_TYP2, SHIPPING_ADDRESS, 1), _defineProperty(_CUSTOMER_ADDRESS_TYP2, BILLING_ADDRESS, 2), _CUSTOMER_ADDRESS_TYP2);
export var CUSTOMER_ADDRESS_TYPES = {
  CURRENT: 'CURRENT',
  PREVIOUS: 'PREVIOUS',
  GARAGE: 'GARAGE'
};
export var COMMUNICATION_TYPES = {
  CALL: 0,
  EMAIL: 1,
  TEXT: 2
};
export var DMS_COMMUNICATION_TYPES = {
  CALL: 'CALL',
  EMAIL: 'EMAIL',
  TEXT: 'TEXT',
  IN_PERSON: 'IN_PERSON',
  ONLINE: 'ONLINE'
};
export var DMS_VS_DSE_COMMUNICATION_TYPES = (_DMS_VS_DSE_COMMUNICA = {}, _defineProperty(_DMS_VS_DSE_COMMUNICA, DMS_COMMUNICATION_TYPES.CALL, COMMUNICATION_TYPES.CALL), _defineProperty(_DMS_VS_DSE_COMMUNICA, DMS_COMMUNICATION_TYPES.TEXT, COMMUNICATION_TYPES.TEXT), _defineProperty(_DMS_VS_DSE_COMMUNICA, DMS_COMMUNICATION_TYPES.EMAIL, COMMUNICATION_TYPES.EMAIL), _DMS_VS_DSE_COMMUNICA);
export var DSE_VS_DMS_COMMUNICATION_TYPES = _reduce(DMS_VS_DSE_COMMUNICATION_TYPES, function (acc, communicationCode, dseCommunicationType) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, communicationCode, dseCommunicationType));
}, {});
export var COMMUNICATION_TYPE_DISPLAY = (_COMMUNICATION_TYPE_D = {}, _defineProperty(_COMMUNICATION_TYPE_D, COMMUNICATION_TYPES.TEXT, 'Text'), _defineProperty(_COMMUNICATION_TYPE_D, COMMUNICATION_TYPES.EMAIL, 'Email'), _defineProperty(_COMMUNICATION_TYPE_D, COMMUNICATION_TYPES.CALL, 'Call'), _COMMUNICATION_TYPE_D);
export var COMMUNICATION_TYPE_OPTIONS = [{
  label: COMMUNICATION_TYPE_DISPLAY[COMMUNICATION_TYPES.CALL],
  value: COMMUNICATION_TYPES.CALL
}, {
  label: COMMUNICATION_TYPE_DISPLAY[COMMUNICATION_TYPES.TEXT],
  value: COMMUNICATION_TYPES.TEXT
}, {
  label: COMMUNICATION_TYPE_DISPLAY[COMMUNICATION_TYPES.EMAIL],
  value: COMMUNICATION_TYPES.EMAIL
}];
export var PHONE_TYPES = {
  MOBILE: 0,
  HOME: 1,
  WORK: 2
};
export var PHONE_TYPE_VS_LABELS = (_PHONE_TYPE_VS_LABELS = {}, _defineProperty(_PHONE_TYPE_VS_LABELS, PHONE_TYPES.MOBILE, __('Mobile')), _defineProperty(_PHONE_TYPE_VS_LABELS, PHONE_TYPES.HOME, __('Home Phone')), _defineProperty(_PHONE_TYPE_VS_LABELS, PHONE_TYPES.WORK, __('Work Phone')), _PHONE_TYPE_VS_LABELS);
export var PHONE_TYPE_OPTIONS = [{
  label: PHONE_TYPE_VS_LABELS[PHONE_TYPES.MOBILE],
  value: PHONE_TYPES.MOBILE
}, {
  label: PHONE_TYPE_VS_LABELS[PHONE_TYPES.HOME],
  value: PHONE_TYPES.HOME
}, {
  label: PHONE_TYPE_VS_LABELS[PHONE_TYPES.WORK],
  value: PHONE_TYPES.WORK
}];
export var PREFERRED_COMMUNICATION_MODE_VS_ICON_NAME = (_PREFERRED_COMMUNICAT = {}, _defineProperty(_PREFERRED_COMMUNICAT, COMMUNICATION_TYPES.CALL, 'icon-call'), _defineProperty(_PREFERRED_COMMUNICAT, COMMUNICATION_TYPES.TEXT, 'icon-call'), _defineProperty(_PREFERRED_COMMUNICAT, COMMUNICATION_TYPES.EMAIL, 'icon-mail'), _PREFERRED_COMMUNICAT);
export var DEFAULT_CUSTOMER_FILTERS = [{
  field: 'status',
  operator: OPERATORS.IN,
  values: [STATUS.ACTIVE]
}];
export var CUSTOMER_NUMBER_PROPERTY_CONSTANTS = {
  MANUAL: 'MANUAL',
  NONE: 'NONE',
  PARTIAL: 'PARTIAL'
};
export var CUSTOMER_ACCOUNTING_TYPE = {
  TAX_EXEMPT: 'TAX_EXEMPT',
  CHARGE_CUSTOMER: 'CHARGE_CUSTOMER'
};
export var CUSTOMER_ACCOUNTING_TYPE_VS_LABEL = (_CUSTOMER_ACCOUNTING_ = {}, _defineProperty(_CUSTOMER_ACCOUNTING_, CUSTOMER_ACCOUNTING_TYPE.TAX_EXEMPT, __('Tax Exempt')), _defineProperty(_CUSTOMER_ACCOUNTING_, CUSTOMER_ACCOUNTING_TYPE.CHARGE_CUSTOMER, __('Charge Customer')), _CUSTOMER_ACCOUNTING_);
export var CUSTOMER_ACCOUNTING_TYPE_VS_ICON = (_CUSTOMER_ACCOUNTING_2 = {}, _defineProperty(_CUSTOMER_ACCOUNTING_2, CUSTOMER_ACCOUNTING_TYPE.TAX_EXEMPT, 'icon-tax-exempt-filled'), _defineProperty(_CUSTOMER_ACCOUNTING_2, CUSTOMER_ACCOUNTING_TYPE.CHARGE_CUSTOMER, 'icon-charge'), _CUSTOMER_ACCOUNTING_2);
export var CUSTOMER_FIELD_IDS = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  BUSINESS_NAME: 'businessName',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL: 'email',
  ADDRESS_LINE_1: 'line1',
  CITY: 'city',
  STATE: 'state',
  COUNTRY: 'country',
  PREFERRED_CONTACT_TYPE: 'preferredContactType',
  POSTAL_CODE: 'postalCode'
};